import { NgModule }                from '@angular/core';
import { CommonModule }            from '@angular/common';
import { FormsModule }             from '@angular/forms';
import { StateRegistComponent }    from './state-regist.component';
import { StateTotalComponent }     from './state-total.component';
import { StateTotalComponentNew } from './state-total-new.component';
import { StateTotalComponentTest }  from './state-total-test.component';
import { NgxMyDatePickerModule }   from 'ngx-mydatepicker';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxMyDatePickerModule
  ],
  declarations: [
    StateRegistComponent,
    StateTotalComponent,
    StateTotalComponentNew,
    StateTotalComponentTest
  ],
  providers: []
})
export class StatementModule{}



// WEBPACK FOOTER //
// ./src/app/statement/statement.module.ts